export const getTripEntityId = (tripData) => {
  if (!tripData) return null;
  return tripData.entity_id ?? tripData.entityId ?? null;
};

export const isTripEntityMatch = (tripData, currentEntity) => {
  const tripEntityId = getTripEntityId(tripData);
  const currentEntityId = currentEntity?.entityId ?? null;
  if (!tripEntityId || !currentEntityId) return false;
  return tripEntityId.toString() === currentEntityId.toString();
};

export const isTripEntityMismatch = (tripData, currentEntity) => {
  const tripEntityId = getTripEntityId(tripData);
  const currentEntityId = currentEntity?.entityId ?? null;
  if (!tripEntityId || !currentEntityId) return false;
  return tripEntityId.toString() !== currentEntityId.toString();
};
